export { default as InputRange } from './input-range';
